import { ModalStore } from "store/modal";

const useModal = () => ModalStore.useState(modalState => modalState);

export { useModal };
